/** 料金が発生しない / 取得できない夜の price 表示ラベル (在庫なし夜・チェックアウト日で共用) */
export const UNAVAILABLE_PRICE_LABEL = "-";
